import { Stack, Typography } from "@mui/material"
import { observer } from "mobx-react-lite"
import StoreAchievement from "../StoreAchievement"
import { useEffect } from "react"

const MonthSelector = observer(() => {

    useEffect(() => {
        // Only set to 0 if no period is selected yet
        if (StoreAchievement.getSelectedPeriod() === '') {
            StoreAchievement.setSelectedPeriod(0)
        }
    }, [])

    return (
        <Stack direction={'row'} gap="24px" justifyContent={'center'}>
            {StoreAchievement.getPeriodsWithMonthName().map((period, index) => (
                <Stack
                    key={period.month}
                    onClick={() => StoreAchievement.setSelectedPeriod(index)}
                    sx={{
                        cursor: 'pointer',
                        borderBottom: StoreAchievement.getSelectedPeriod() === index ? '2px solid rgba(255, 183, 79, 1)' : 'none'
                    }}>
                    <Typography
                        fontFamily={'Poppins'}
                        fontSize={'14px'}
                        color={StoreAchievement.getSelectedPeriod() === index ? 'rgb(0, 0, 0)' : 'rgba(138, 155, 176, 1)'}
                        fontWeight={StoreAchievement.getSelectedPeriod() === index ? 600 : 400}>
                        {period.monthName}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    )
})

export default MonthSelector